//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.PartOperationBuilder.js";
import "../no/BasePart.js";
let d=[[[0,"DependentFilesToCopyOption",1,0],[0,"ReplaceAllComponentsInSession",1,0]],[[["selectedParts","nFailedParts","failedParts"],"SetSelectedPartsToCopy",{},1,0],[["basePart","relatedParts","relatedPartsReasons","operation"],"AddRelatedPartsToCopy",{},4,0],[["logicalObject"],"CreateNonMasterListForCopyLogicalObject",{},1,1],[["logicalObject","numParts"],"GetNonMasterListForCopyLogicalObject",{R_:{partFileNames:""}},1,1],[["logicalObject","part_name"],"IsNonMasterForLogicalObjectBeingCopied",{R_:{do_save_as:''}},2,1],[["logicalObject"],"GetCopyNonMasterPartsOption",{R_:{saveOption:''}},1,1],[["logicalObject","saveOption"],"SetCopyNonMasterPartsOption",{},2,1],[["logicalObject","partName"],"SetSelectedNonMasterToCopy",{},2,1],[["logicalObject","oldName","newName"],"EditNonMasterToCopyName",{R_:{isNameValid:''}},3,1],[[],"GetOperationSubType",{R_:{dialogOperation:''}},0,0],[["operationSubType"],"SetOperationSubType",{},1,0],[["logicalObject"],"GetSourcePartFromLogicalObject",{R_:{sourcePart:"Part"}},1,0],[["ecnCliSpec"],"SetChangeNotice",{},1,0]],[]];
SPLM.PDM.PartOperationCopyBuilder = class extends SPLM.PDM.PartOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.PartOperationCopyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PartOperationCopyBuilder.CopyNonMasterParts = Object.freeze({
    "All" : "All", "None" : "None"});

SPLM.PDM.PartOperationCopyBuilder.CopyDependentFiles = Object.freeze({
    "All" : "All", "None" : "None"});

SPLM.PDM.PartOperationCopyBuilder.OperationSubType = Object.freeze({
    "Default" : "Default", "MakeUnique" : "MakeUnique"});

export default SPLM;